import { HsCodeAdditionalFields } from '../../../../models/hsCode';

const additionalFieldToTransKey: Record<HsCodeAdditionalFields, string> = {
  imei: 'UZ_IMEI_title',
};

export const getAdditionalFieldTransKey = (fieldName: string) =>
  additionalFieldToTransKey[fieldName as HsCodeAdditionalFields];
